import { createSlice } from '@reduxjs/toolkit';

export const submissionStatus = createSlice({
  name: 'SUBMISSION_STATUS',
  initialState: {}, // comes from preloadedState in the store

  reducers: {
    update(_state, action) {
      return action.payload;
    },
  },
});

const { actions, reducer } = submissionStatus;

export const { update } = actions;

export default reducer;
